import React from "react";
import { classnames, Icon } from "@culturehq/components";
import { SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";
import { Trans } from "app/utils";
import { CurrentOption } from "./EffectsSDKCameraRecorder";
import MonitorIcon from "../icons/MonitorIcon";

interface ScreenOptionProps {
  currentOption: CurrentOption;
  isDisableOption: (option: CurrentOption) => boolean;
  onSelectRecordMethod: (value: string | SelectValueWithCategory | null) => void;
}

const ScreenOption: React.FC<ScreenOptionProps> = ({
  currentOption,
  isDisableOption,
  onSelectRecordMethod
}) => (
  <div
    data-testid="screen-option"
    className={classnames("Options-Container__source", isDisableOption("screen") ? "disabled" : "")}
  >
    {currentOption === "screen" && (
      <div
        data-testid="screen-option-menu"
        className="option-menu option-menu__screen chq-ffd--sl--opts chq-ffd--sl--opts-open"
      />
    )}
    <div
      className="option"
      onClick={() => onSelectRecordMethod("screen")}
      data-testid="screen-option-button"
    >
      <div className="icon-container">
        {currentOption === "screen" ? (
          <Icon className="icon-container__icon" icon="close" />
        ) : <MonitorIcon className="icon-container__icon" />}
      </div>
      <span className="option-legend"><Trans>Screen</Trans></span>
    </div>
  </div>
);

export default ScreenOption;
